import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { DelinquentBillService } from './delinquent-bill.service';

@Injectable()
export class DelinquentBillInterceptor implements HttpInterceptor 
{
  constructor(private readonly injector: Injector) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler) 
{
    return next.handle(req).pipe(
      map(event => 
{
        if (event instanceof HttpResponse) 
{
          // Filter search results for delinquent bills
          if (req.url.includes('/api/elastic/') && event.body?.accounts) 
{
            const delinquentBillService = this.injector.get(DelinquentBillService);
            event.body.accounts = event.body.accounts.filter((account: any) => 
{
              // Keep accounts that have non-delinquent bills or no delinquent bills to block
              const hasNonDelinquentBills = account.bills?.some((bill: any) => !bill.delinquent);
              const hasBlockedDelinquentBills = account.bills?.some((bill: any) => 
                delinquentBillService.shouldBlockFromSearch(bill)
              );
              return hasNonDelinquentBills || !hasBlockedDelinquentBills;
            });
          }
        }
        return event;
      })
    );
  }
}